module.exports = __webpack_public_path__ + "img/reimu hakurei lunar war shaman_lw.9d079271.png";